import {RingSize} from '@components/common/base/common/ring'
import {AvatarSize} from './types'
import {StatusSize} from '@components/common/base/user-status'

export const getOutlineSize = (size: AvatarSize): RingSize => {
  switch (size) {
    case 16:
    case 20:
      return 1
    case 24:
    case 32:
    case 40:
    case 48:
    case 56:
      return 2
    default:
      throw new Error(`Unsupported size: ${size}`)
  }
}

export const getStatusSize = (size: AvatarSize): StatusSize => {
  switch (size) {
    case 16:
    case 20:
      return 4
    case 24:
      return 6
    case 32:
    case 40:
      return 8
    case 48:
      return 10
    case 56:
      return 12
    default:
      throw new Error(`Unsupported size: ${size}`)
  }
}

export const emptyAvatar = 'url("/img/empty-avatar@2x.png")'

export const getSize = (size: AvatarSize): string => {
  switch (size) {
    case 16:
      return 'w-16 h-16'
    case 20:
      return 'w-20 h-20'
    case 24:
      return 'w-24 h-24'
    case 32:
      return 'w-32 h-32'
    case 40:
      return 'w-40 h-40'
    case 48:
      return 'w-48 h-48'
    case 56:
      return 'w-56 h-56'
    default:
      throw new Error(`Unsupported size: ${size}`)
  }
}
